import { InputProps } from "./Input";
import style from "./Input.module.scss";

const TextArea = ({
  label,
  type = "text",
  errorMessage,
  disabled = false,
  marginBottom = true,
  prefixIcon = "",
  register,
  name,
}: InputProps) => {
  return (
    <div
      className={`${style.inputField} ${prefixIcon && style.prefixIcon} ${
        !marginBottom && style.noSpacing
      }`}
    >
      <div className={style.inputField__inner}>
        <textarea
          type={type}
          placeholder={label}
          disabled={disabled}
          {...register(name)}
        />
      </div>
      {errorMessage && <span>{errorMessage}</span>}
    </div>
  );
};
export default TextArea;
